let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lsIY1")).then(() => parcelRequire('aLDUW'));